<template>
  <div class="errors">
    <div class="error--main">
      <div class="error__title">
        <img src="/img/icon-warning.svg" class="error__icon" />
        <span v-if="errors.main.code"
          >{{ errors.main.code }}: </span
        >
        {{ errors.main.title }}
      </div>
      <div class="error__message">{{ errors.main.message || hint }}</div>
      <div
        v-show="showButton"
        id="errorBtn"
        class="startBtn"
        @click="handleErrorBtnClick(errors.main.btnLink)"
      >
        {{ errors.main.btnText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hint: 'Versuchen Sie es erneut oder wenden Sie sich an support@eligo.de.',
    };
  },

  computed: {
    showButton () {
      return this.errors.main.showBtn && !this.$store.state.isOnSite && !this.$route.query['on-site'];
    },
    errors() {
      const [main = {}, ...all] = this.$store.state.errors;
      return { main, all };
    },
  },

  methods: {
    handleErrorBtnClick(link) {
      let cstm = this.$store.state.cstm;
      window.location.href = `/${cstm}/landing`;
    },
  },
};
</script>

<style lang="scss" scoped>
.error--main {
  margin-bottom: 24px;

  .error {
    &__title {
      font-size: 2em;
    }
    &__icon {
      display: inline-block;
    }
    &__message {
      font-size: 1.2em;
      padding-left: 56px;
    }
  }
}
#errorBtn {
  width: 14em;
  text-align: center;
  margin: auto;
  margin-top: 2em;
  color: #000;
}
</style>
